import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { BrandingPage } from '@/features/branding/components/branding-page'

export const Route = createFileRoute('/_app/account/branding')({
  component: BrandingRoute,
})

function BrandingRoute(): JSX.Element {
  return <BrandingPage />
}
